module.exports = __webpack_public_path__ + "img/218e872.PNG";